import * as types from '../types/reviewTypes';
import * as reviewService from '../../services/reviewService';
import { addReview } from '../../utils/activityStore';

export const fetchReviews = (category, id) => async (dispatch) => {
  dispatch({ type: types.FETCH_REVIEWS_REQUEST });
  try {
    const data = await reviewService.getReviews(category, id);
    dispatch({ type: types.FETCH_REVIEWS_SUCCESS, payload: data.reviews || [] });
  } catch (err) {
    dispatch({
      type: types.FETCH_REVIEWS_FAILURE,
      payload: err?.response?.data?.error || err?.message || 'Failed to load reviews',
    });
  }
};

export const submitReview = (category, id, { rating, text, title }) => async (dispatch) => {
  try {
    if (title) addReview({ title, rating, text });
    await reviewService.createReview(category, id, { rating, text, title });
    dispatch({ type: types.SUBMIT_REVIEW_DONE, payload: true });
    const data = await reviewService.getReviews(category, id);
    dispatch({ type: types.FETCH_REVIEWS_SUCCESS, payload: data.reviews || [] });
    return { success: true };
  } catch (err) {
    dispatch({
      type: types.FETCH_REVIEWS_FAILURE,
      payload: err?.response?.data?.error || err?.message || 'Failed to submit review',
    });
    return { success: false, message: err?.response?.data?.error || err?.message || 'Failed to submit review' };
  }
};
